import React, {
  Fragment,
} from 'react';
import PropTypes from 'prop-types';
import {Row,Col,Form,Select,Button,PageHeader,Modal,Input,Upload,Table,Typography, Space
} from 'antd';
import qs from 'qs';
import { DoubleRightOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import { TableView } from 'components';
import { connect } from 'dva';
import axios from 'axios'

const { Option } = Select;
const { confirm } = Modal;
const { Search } = Input;
const {Link} = Typography;
// axios.defaults.transformRequest = [function (data) {
//   let ret = ''
//   for (let it in data) {
//       ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//   }
//   return ret
// }]

class ApplicationManage extends React.Component {
  formRef = React.createRef()
  constructor(props) {
    super(props);
    this.state = {
     
      paginationProps: {
        pageSize: 10,  //表格每一页的数据量
        totalpage: 1, //第几页
        total: '', //数据总量
        workStatus:'',
        appKey:'',
        },
      showForm: false,
      editData:{},
      list:'',
      isModalVisible:false,
      isShowEdit:false,
      isShowSearch:false,
      isShowSearch2:false,
      formData:[],
      remind:[],
      selectedRowKeys: [],
      txuserName:{},
      editAfterData:{
        appKey:'' , 
        certificateType: '',
        workStatus:'',
        certificatePwd:'',
        packageName:'',
      },
      txObject:{
        limit:'1',
        page:'1',
        id:'',
        realName: '',
        total:''
        
      },
      addObject:[]
      
    };
    this.handleClick = this.handleClick.bind(this);
  }
  
  getPeronList = () => {
    axios({
      method: 'post',
      url:'https://office.yunbiaokj.com:40005/mxmService/certificate/list',
      // headers:{'Content-Type': 'application/json'},
      data: {
        appKey:this.state.paginationProps.appKey,
        limit:this.state.paginationProps.pageSize,
        page:this.state.paginationProps.totalpage,
        workStatus:this.state.paginationProps.workStatus
      }
    }).then((res)=>{
      const timeData = res.data.page.list
      
            let dateObj = timeData.map(v => ({
                ...v,
                cerTime:(`${new Date(v.startTime).getFullYear()}-${new Date(v.startTime).getMonth() + 1}-${new Date(v.startTime).getDate()}~${new Date(v.endTime).getFullYear()}-${new Date(v.endTime).getMonth() + 1}-${new Date(v.endTime).getDate()}`),
                cerType:this.ccertificateType(v.certificateType),
                appname:v.knApplicationInfo.title,
                workStatus:this.ccertificateStatus(v.workStatus),
            }))
            this.setState((state) => {
              return {
                formData:dateObj,
                paginationProps: {...state.paginationProps,total:res.data.page.totalCount}
              }
            })
    })
  }

  changeFormValue = (first, all) => {
    this.setState((state) => {
      return {
          editAfterData: { ...state.editAfterData, appKey: all.appname, certificateType: all.cerType,workStatus:all.cerBy,certificatePwd:all.cerPossword }
      }
  })
  }
 
  showEdit = (id) => {
    axios({
      method:'post',
      url:'https://office.yunbiaokj.com:40005/mxmService/certificate/info/'+this.state.formData[id].id
    }).then((res) => {
      // console.log(this.formRef);
      const editData = res.data.info
      // console.log(editData);
      this.setState(() =>{
        return{
          editData
        }
      },()=>{
        this.selectRemind()
      })
      this.formRef.current.setFieldsValue({  //动态绑定表单的值   key为表单的name   value为state的动态值
        appname: this.state.editData.appKey,
        cerType: this.state.editData.certificateType,
        cerBy:this.state.editData.workStatus,
        cerPossword:this.state.editData.certificatePwd
  
  
    })
    })
    this.setState({
      isShowEdit:true,
      
      
    })
    
  }

  setFieldsValue = (res)=>{
    console.log(res)
  }

  selectRemind = () => {
    axios({
      
      method:'post',
      url:'https://office.yunbiaokj.com:40005/mxmService/certificate/select_Remind_Scope',
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest: [function (data) {
                        data = qs.stringify(data)
                        return data }],
      data: {
        id:this.state.editData.id
      }
      
    }).then((res) =>{
      const remind = res.data.remindScope
      let tempArray = remind.map(item => { //遍历出对象
        return item.userName
      })
      // console.log(tempArray);
      let txuserName =  tempArray.join(',')
      // console.log(userName);
      this.setState(() =>{
      return {
        remind,
        txuserName
      }
    })
    })
    
  }
  handleClick() {
    this.setState({showForm: !this.state.showForm})
  }

  showAdd = () => {
    this.setState({
      isModalVisible:true
    })
  }

  handleOk = () => {
    this.setState({
      isModalVisible:false
    })
  }

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  }


  addSearch2 = () => {
    axios({
      method:'post',
      url:'https://office.yunbiaokj.com:40005/uc/emp/v6/selectEmpList',
      data:{
        id:this.state.txObject.id,
        limit:this.state.txObject.limit,
        page:this.state.txObject.page,
        realName:this.state.txObject.realName
      }
    }).then((res) =>{
      // console.log(res)
     const addObject = res.data.data
     console.log(addObject)
     this.setState((state) =>{
      return {
        addObject,
        txObject: {...state.txObject,total:res.data.total}
      }
    })
    })
    this.setState({
      isShowSearch2:true,
      
      
    })
    
  }
  showEditOk = ()  => {
    this.setState({
      isShowEdit:false
    })
  }
  showEditCancel = () => {
    this.setState({
      isShowEdit:false
    })
  }
  showDelete = () => {
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定删除吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk:()=>{
        const arr =new Array(0);
        arr.push(this.state.formData[0].id)
        axios({
          method:'post',
          url:'https://office.yunbiaokj.com:40005/mxmService/certificate/delete',
          data: arr
        }).then(() =>{
          this.getPeronList()
        })
        
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  addSearch = () => {
    this.setState({
      isShowSearch:true
    })
  }
  showSearchOk =() => {
    this.setState({
      isShowSearch:false
    })
  }
  showSearchCancel =() => {
    this.setState({
      isShowSearch:false
    })
  }
  showSearchOk2 = () => {
    this.setState({
      isShowSearch2:false
    })
  }
  showSearchCancel2 = () => {
    this.setState({
      isShowSearch2:false
    })
  }
  ccertificateType = (res) => {
    switch (res) {
      case 'PUSH':
          return '推送证书'
      case 'RELEASE':
          return '发布证书'
      default:
          return null
  }
  }
  ccertificateStatus =(res) => {
    switch (res) {
      case 'USEABLE':
        return '可用'
      case 'UNEABLE' : 
      return '不可用'
      default:
          return null
    }
  }
  componentDidMount(){
    this.getPeronList()
  }
  getSearch = ()  => {
    if (this.state.paginationProps.workStatus === '') {
      return
  }
  this.getPeronList()
  }
  reach = () => {
    this.setState((state) => {
      state.paginationProps.workStatus = ''
      this.getPeronList();
  })
  }
  getSelectData = (value) => {
    this.setState((state) => {
      return {
          paginationProps: { ...state.paginationProps, workStatus: value }
      }
  })
  }   
  
  pagechange = (pages) => {
    this.setState((pre) => {
        pre.paginationProps.page = pages.pageSize
        this.getPeronList()
    })
}
  txcurrentchange = (pages) => {
    this.setState((pre) =>{
      pre.txObject.page = pages.current
      this.addSearch2()
    })
  }
  addList = (data) => {
      console.log(data);
      this.state.remind.push(data)
    // this.setState((state) =>{
    //   remind:[...remind]
    // })
console.log(this.state.remind)
     
  }

  onSelectChange = selectedRowKeys => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };
  render() {
    const {formData,showForm,isModalVisible,isShowEdit,isShowSearch,paginationProps,editData,remind,isShowSearch2,selectedRowKeys,txuserName,addObject} = this.state;
    const tableProps = {
      columns: [
        {
          title: '应用名称',
          dataIndex: 'appname',
          key:'appname'
        },
        {
          title: '证书类型',
          dataIndex: 'cerType',
          key: 'cerType',
        },
        {
          title: '证书密码',
          dataIndex: 'certificatePwd',
          key: 'certificatePwd',
        },
        {
          title: '证书状态',
          dataIndex: 'workStatus',
          key: 'workStatus',
        },
        {
          title: '证书有效期',
          dataIndex: 'cerTime',
          key: 'cerTime',
        },
        {
          title: '操作',
          width: 160,
          align: 'center',
          render: (val, record, index) => <Fragment>
            <Button type="link" onClick={()=>{this.showEdit(index)}}>编辑</Button>
            <Button type="link" onClick={this.showDelete}>删除</Button>
           
          </Fragment>
        },
      ],
      rows: formData,
      pageParam: {
        // onchange:this.pagechange,
        total:paginationProps.total,//数据总数
        pageSize:paginationProps.pageSize,//当前分页数
        current:paginationProps.totalpage,//当前页码
        
      }
    };
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const chanidDolumns1 = [
      {
        title: '姓名',
        dataIndex: 'realname',
        key:'realname'
      },
      {
        title: '所在部门',
        dataIndex: 'organizationName',
        key:'organizationName'
      },
      {
        title: '操作', render: (text, record, index) => (
          <a onClick={()=>this.addList(record)}>加入</a>
        )
      }
    ];
    const chanidDolumns2 = [
      {
        title: '姓名',
        dataIndex: 'userName',
        key:'userName'
      },
      {
        title: '所在部门',
        
      },
      {
        title: '操作',
        render: (text, record, index) => (
          <a>移除</a>
        )
      }
    ];
    return (
      <div className="app-body" style={{textAlign: 'center'}}>
        <PageHeader
            ghost={false}
            className="gray-header"
            title={
              <div>
                <Button type="gray" onClick={this.showAdd}>新增</Button>
              </div>
            }
          extra={[
            <Button className="pos-bottom"
                    key="1"
                    onClick={this.handleClick}
                    icon={<DoubleRightOutlined rotate={showForm ? 270 : 90} />}>{showForm ? '关闭查询' : '展开查询'}</Button>
          ]}
       />
        <Form
          name="basic"
          className="top-search-box"
          style={{display: showForm ? 'block' : 'none'}}
        >
          <Row gutter={16}>
            <Col span={5}>
            <Form.Item name="gender" label="证书状态">
           <Select placeholder="证书状态" onSelect={this.getSelectData} value={paginationProps.workStatus}>
           <Option value="USEABLE">可用</Option>
           <Option value="UNEABLE">不可用</Option>
           </Select>
             </Form.Item> 
            </Col>
            <Col span={4} style={{ textAlign: 'right' }}>
              <Button type="danger" onClick={this.getSearch}>
                搜索
              </Button>
              &emsp;
              <Button style={{ margin: '0 8px' }} onClick={this.reach}>
                重置
              </Button>
            </Col>
          </Row>
        </Form>
        <div className="page-main-box">
          <TableView {...tableProps} />
        </div>
        <Modal title="新增证书" 
                maskClosable={false}
                visible={isModalVisible}
                onCancel={this.handleCancel}
                destroyOnClose
                width={650}
                footer={[
                  <Button type='primary' onClick={this.handleOk} >
                    保存
                  </Button>,
                  <Button key="back" onClick={this.handleCancel}>
                    取消
                  </Button>]}
                >
                  <Form 
                  colon={false} 
                  
                  >  
        <Form.Item name="appname"  label="应用名称" rules={[{ required: true}]} >
          <Select
            placeholder="应用名称"
          >
          <option value='appnameOption'>美涂士工程中心CRM</option>
          </Select>
        </Form.Item>

        <Form.Item name="cerType" label="证书类型" rules={[{ required: true}]}>
          <Select
            placeholder="请选择"
          >
          <option value='certypeOption'>推送证书</option>
          </Select>
        </Form.Item>

        <Form.Item name="cerBy" label="证书状态" rules={[{ required: true}]}>
          <Select
            placeholder="请选择"
          >
          <Option value="cerbyOption">可用</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="证书密码"
          name="cerPossword"
          rules={[{ required: true,message: '请输入证书密码'}]}
        >
          <Input placeholder="证书密码" />
        </Form.Item>

        <Row>
        <Col span={14}>
        <Form.Item
          label="上传文件"
          name="upfile"
          rules={[{ required: true}]}
        >
          <Input readonly="readonly" defaultValue='666'/>
        </Form.Item>
        </Col>
        <Col span={3} offset={6}>
        <Upload showUploadList={false}>
      <Button type='primary'>上传文件</Button>
    </Upload>
        </Col>
      </Row>

      <Form.Item
          label="提醒对象"
          name="reObject"
          rules={[{ required: true,message: '请输入证书密码'}]}
        >
      <Input.Search placeholder="点击指定证书到期提醒范围" readonly="readonly" onClick={this.addSearch}
      onSearch={this.addSearch}
      />
     
        </Form.Item>

        </Form>
    </Modal>
        <Modal title="编辑证书" 
                maskClosable={false}
                visible={isShowEdit}
                onCancel={this.showEditCancel}
                destroyOnClose
                width={650}
                footer={[
                  <Button type='primary' onClick={this.showEditOk} >
                    保存
                  </Button>,
                  <Button key="back" onClick={this.showEditCancel}>
                    取消
                  </Button>]}
                >
              <Form colon={false} ref={this.formRef} onValuesChange={this.changeFormValue}>  
                <Form.Item initialValue={editData.appKey} name="appname"  label="应用名称" rules={[{ required: true}]} >
                  <Select
                    // defaultValue={editData.appId}
                    // onSelect={this.getAppname}
                  >
                    <Select.Option value='6501ea93-e04c-485d-aa98-4180b475ba3a'>测试新增图片222</Select.Option>
                    <Select.Option value='b9feff12-8b14-432a-9b16-0d6caf562b89'>测试新增图片111</Select.Option>
                    <Select.Option value='a448cde4-d274-4aaf-ba97-9dbe727578b7'>测试新增图片</Select.Option>
                    <Select.Option value='edd09f3d-dab4-4e1d-b802-17f1370bf64e'>美涂士工程中心CRM</Select.Option>
                  </Select>
                </Form.Item>

        <Form.Item initialValue={editData.certificateType} name="cerType" label="证书类型" rules={[{ required: true}]}>
          <Select
          // defaultValue={editData.certificateType}
          >
          <Select.Option value='PUSH'>推送证书</Select.Option>
          <Select.Option value='RELEASE'>发布证书</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item initialValue={editData.workStatus} name="cerBy" label="证书状态" rules={[{ required: true}]}>
          <Select
            // defaultValue={editData.workStatus}
          >
          <Select.Option value="USEABLE">可用</Select.Option>
          <Select.Option value="UNEABLE">不可用</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="证书密码"
          initialValue={editData.certificatePwd}
          name="cerPossword"
          rules={[{ required: true,message: '请输入证书密码'}]}
        >
          <Input disabled />
        </Form.Item>

        <Row>
        <Col span={14}>
        <Form.Item
          label="上传文件"
          name="upfile"
          rules={[{ required: true}]}
        >
          <Link href={`https://office.yunbiaokj.com:40005/mxm/api/v4/attachment/id/${editData.appId}`}>
            {editData.packageName}
          </Link>
        </Form.Item>
        </Col>
        <Col span={3} offset={6}>
        <Upload showUploadList={false}>
          <Button type='primary'>上传文件</Button>
        </Upload>
        </Col>
      </Row>

      <Form.Item
          label="提醒对象"
          name="reObject"
          rules={[{ required: true,message: '请输入证书密码'}]}
        >
      <Input.Search placeholder={txuserName} readonly="readonly" onClick={this.addSearch2}
      onSearch={this.addSearch2} />
     
        </Form.Item>

        </Form>
    </Modal>
        <Modal title={[
          <div>
            添加用户
            <Button type="gray" style={{textAlign:'center',marginLeft:315}}>按人员</Button>
          </div>
        ]}
          maskClosable={false}
          visible={isShowSearch}
          onCancel={this.showSearchCancel}
          destroyOnClose
          width={880} 
         
          footer={[
            <Button type='primary' onClick={this.showSearchOk} >确定</Button>,
            <Button key="back" onClick={this.showSearchCancel}>取消</Button>]}
        >
        
          <Row >
          <Col span={11}>
          <Space size={89}>
            <b>待添加</b>
            <Search placeholder="搜索人员"  style={{ width: 250 }} />
            </Space>
            <Table
          size='small'
          columns={chanidDolumns1}
          dataSource={addObject}
          bordered
          />
          <Button>批量添加</Button>
          </Col>
          <Col span={2}> <p></p></Col>
          <Col span={11}>
          <Space size={89}>
            <b>已添加</b>
            <Search placeholder="搜索人员"  style={{ width: 250 }} />
            </Space>
            
            <Table
          size='small'
          columns={chanidDolumns1}
          dataSource={addObject}
          bordered
          />
          <Button>批量移除</Button>
          </Col>
          </Row>
          
       
    </Modal>
    <Modal title={[
          <div>
            添加用户
            <Button type="gray" style={{textAlign:'center',marginLeft:315}}>按人员</Button>
          </div>
        ]}
          maskClosable={false}
          visible={isShowSearch2}
          onCancel={this.showSearchCancel2}
          destroyOnClose
          width={880} 
         
          footer={[
            <Button type='primary' onClick={this.showSearchOk2} >确定</Button>,
            <Button key="back" onClick={this.showSearchCancel2}>取消</Button>]}
        >
        
          <Row >
          <Col span={11}>
            <Space size={89}>
            <b>待添加</b>
            <Search placeholder="搜索人员"  style={{ width: 250 }} />
            </Space>
            <Table
          size='small'
          rowKey='id'
          pagination={this.state.txObject}
          onChange={this.txcurrentchange}
          rowSelection={rowSelection} 
          columns={chanidDolumns1}
          dataSource={addObject}
          bordered
          />
          <Button>批量添加</Button>
          </Col>
          <Col span={2}> <p></p></Col>
          <Col span={11}>
          <Space size={89}>
            <b>已添加</b>
            <Search placeholder="搜索人员"  style={{ width: 250 }} />
            </Space>
          <Table
          size='small'
          rowKey='id'
          rowSelection={rowSelection}
          columns={chanidDolumns2}
          dataSource={remind}
          bordered
          />
          <Button>批量移除</Button>
          </Col>
          </Row>
          
       
    </Modal>
      </div>
    )
  }
}

ApplicationManage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loginInfo: PropTypes.object,
};
export default connect(({ applicationManage }) => applicationManage)(ApplicationManage);
